import PropTypes from "prop-types";
import cx from "classnames";
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ViewList from "@material-ui/icons/ViewList";
import MoreVert from "@material-ui/icons/MoreVert";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import Button from "components/CustomButtons/Button.js";
import AdminNavbarLinks from "./AdminNavbarLinks";

const useStyles = makeStyles(styles);
export default function AdminNavbar(props) {
  const classes = useStyles();
  let { color, rtlActive, brandText } = props;
  if (!brandText) {
    if (window.location.href.indexOf('edit-device') >= 0) {
      brandText = 'Device Table'
    } else if (window.location.href.indexOf('edit-manufacturer') >= 0) {
      brandText = 'Edit Manufacturer'
    } else if (window.location.href.indexOf('edit-user') >= 0) {
      brandText = 'Edit User'
    } else if (window.location.href.indexOf('edit-patient') >= 0) {
      brandText = 'Edit Resident'
    } else if (window.location.href.indexOf('edit-company') >= 0) {
      brandText = 'Edit Company'
    } else if (window.location.href.indexOf('add-device') >= 0) {
      brandText = 'Create Device'
    } else if (window.location.href.indexOf('add-manufacturer') >= 0) {
      brandText = 'Create Manufacturer'
    } else if (window.location.href.indexOf('add-user') >= 0) {
      brandText = 'Create User'
    } else if (window.location.href.indexOf('add-resident') >= 0) {
      brandText = 'Create Resident'
    } else if (window.location.href.indexOf('add-company') >= 0) {
      brandText = 'Create Company'
    } else if (window.location.href.indexOf('create-facility') >= 0) {
      brandText = 'Create Facility'
    }
  }
  const appBarClasses = cx({
    [" " + classes[color]]: color,
  });
  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive,
    });
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css">
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
              >
                <ViewList className={classes.sidebarMiniIcon} />
              </Button>
            ) : (
                <Button
                  justIcon
                  round
                  color="white"
                  onClick={props.sidebarMinimize}
                >
                  <MoreVert className={classes.sidebarMiniIcon} />
                </Button>
              )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button href="#" className={classes.title} color="transparent">
            {brandText}
          </Button>
        </div>
        <Hidden smDown implementation="css">
          <AdminNavbarLinks rtlActive={rtlActive} />
        </Hidden>
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
};
